import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_NDVI } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const NDVIExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='ndvi-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.ndvi.explainers.howDoMeasureThis.headline')}</ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy body={t('shared.ncaDetail.details.ndvi.explainers.howDoMeasureThis.body')} />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_NDVI} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
